<template>
<div class="done_wraps">
   <img src="~@/assets/done.svg" alt="done">
   <h4>TIMEN ER REGISTRERT</h4>
   <p>Vi bekreftet at timen din er registrert og ønsker deg velkommen til {{get_setting.name}}</p>
   <!-- <p>to watch reservation information click <router-link to="/">here</router-link> </p> -->
   <router-link class="back_booking" to="/booking">Booking Again</router-link>
   
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "doneApp",
  data(){
    return{}
  },
  computed:{
    ...mapGetters({
      get_setting:'get_setting'
    })
  },
  methods:{
    ...mapActions({})
  },
  mounted(){}
};
</script>
<style lang="scss" scoped>
.done_wraps{
    padding-top: 80px;
    padding-bottom: 80px;
    text-align: center;
    img{
        height: 300px;
    }
    h4{
        font-size: 1.8rem;
        font-weight: 500;
        padding-top: 20px;
        letter-spacing: 0.5px;
        margin: 0;
        color:var(--active_color)
    }
    p{
        font-size: 15px;
        font-weight: 400;
        color: white;
        opacity: 0.8;
        margin: 0;
        a{
            color:var(--active_color);
        }
    }
    .back_booking{
    background-color: var(--active_color);
    color: white;
    padding: 8px 20px;
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    width: 160px;
    text-align: center;
    border-radius: 30px;
    font-weight: 500;
    font-size: 16px;
    transition: 0.4s ease-in-out;
    margin-top: 20px;
     border: 1px solid transparent;
}
.back_booking:hover{
    background-color: black;
    border: 1px solid var(--active_color);
    color: var(--active_color) !important;
}
}
</style>